<template>

  <div class="row">

    <div class="col-12 col-md-6 form-group">
      <label for="min_order_value" class="col-form-label">{{ $t('flexben.benefit.fields.min_order_value')
        }}</label>
      <input id="min_order_value" type="number" class="form-control" min="0" v-model="fields.min_order_value">
    </div>
    <div class="col-12 text-danger">{{ $t('flexben.benefit.fields.info_contract_number') }}</div>
    <div class="row mt-4 form-group">
      <span id="medical_threshold_description"
            class="d-inline-block flexben-tooltip-icon ml-2 text-bold">i</span>
      <b-tooltip :target="'medical_threshold_description'" variant="flexben" placement="topleft">
        <div class="text-left">{{$t('flexben.benefit.thresholds.tooltip_medical', {value:'medical_insurance'})}}</div>
      </b-tooltip>
      <label for="threshold" class="form-fields-required text-bold mb-0 ml-2 mr-2 col-form-label p-0">
        {{ $t('flexben.benefit.thresholds.' + 'medical_insurance') }}</label>

      <b-form-checkbox id="threshold" class="float-right"
                       v-model="medicalInsuranceLimit"
                       :disabled=true
                       switch></b-form-checkbox>
    </div>
  </div>

</template>

<script>
export default {
  name: "BenefitMedicalInsurance",
  props: {
    fields: {
      type: Object,
      default: function () {
        return {min_order_value: 100};
      },
      required: true
    },
    errorsBag: {
      type: Object,
      default: function () {
        return {};
      },
      required: true
    }
  },
  data: function () {
    return {
      medicalInsuranceLimit: true
    }
  }
}
</script>
